import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}

export const getPrintRealease = async (
  oid: number[],
  user: string
): Promise<string> => {
  try {
    const res = await apiClient.post<ApiResponse<string>>(
      Endpoints.ImprimirComprobanteLiberacion,
      {
        oids: oid,
        usuario: user,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
